import { render, staticRenderFns } from "./campaign-icon.vue?vue&type=template&id=4b4624e1"
import script from "./campaign-icon.vue?vue&type=script&lang=js"
export * from "./campaign-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports